// extracted by mini-css-extract-plugin
module.exports = {"tabListWrapper":"styles_tabListWrapper__uNTry","tabList":"styles_tabList__RUz43","tabPanels":"styles_tabPanels__onex7","tab":"styles_tab__I8HwC","tabselected":"styles_tabselected__viJU_","tabnotselected":"styles_tabnotselected__xI8t_"};
module.exports.__checksum = "091631bc1bef"
